/**
 * Загрузка выписки 1С — разметка 1:1 с legacy htdocs/core/templates/admin_bankparse.tpl:
 * форма multipart с полем bankparsefile и кнопкой «распарсить выписку 1с».
 *
 * Отправка: POST /api/admin/bank/parse (Handlers\Admin\Transactions::bankParse),
 * бекенд возвращает {parsed, imported, skipped} — legacy после разбора просто
 * перерисовывал страницу, поэтому итог показан текстом под формой.
 */

import { useRef, useState } from 'react'

import { api, ApiError } from '@/api/client'

/** Ответ POST /api/admin/bank/parse. */
interface BankParseResult {
  parsed: number
  imported: number
  skipped: number
}

export function AdminBankParsePage() {
  const fileInput = useRef<HTMLInputElement>(null)
  const [result, setResult] = useState<BankParseResult | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [sending, setSending] = useState(false)

  const submit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault()

    const file = fileInput.current?.files?.[0]
    if (file === undefined) {
      setError('Файл выписки не загружен')
      return
    }

    const form = new FormData()
    form.append('bankparsefile', file)

    setSending(true)
    setError(null)
    setResult(null)
    try {
      setResult(await api.upload<BankParseResult>('/api/admin/bank/parse', form))
    } catch (e: unknown) {
      setError(e instanceof ApiError ? e.message : 'Ошибка при разборе выписки')
    } finally {
      setSending(false)
    }
  }

  return (
    <form method="post" encType="multipart/form-data" onSubmit={(e) => void submit(e)}>
      <input type="file" name="bankparsefile" id="" ref={fileInput} />
      <input type="submit" name="bankparse" value="распарсить выписку 1с" disabled={sending} />

      {error !== null && <p style={{ color: '#ce4844' }}>{error}</p>}
      {result !== null && (
        <p>
          Обработано документов: {result.parsed}, загружено: {result.imported}, пропущено
          (уже есть в базе): {result.skipped}
        </p>
      )}
    </form>
  )
}
